import {
  MorphemeMnemonicsPanelContentRoot,
  MorphemeMnemonicsPronunciationViewTab,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content";

export function GraphemeMnemonicsPronunciationScreenSuspense({
  selectedPinyin,
}: {
  selectedPinyin: string;
}) {
  return (
    <MorphemeMnemonicsPanelContentRoot>
      <MorphemeMnemonicsPronunciationViewTab selectedPinyin={selectedPinyin} />
    </MorphemeMnemonicsPanelContentRoot>
  );
}
